import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const ChangeKVModal = ({ isOpen, onClose, installation, onConfirm }) => {
  const [selectedKVId, setSelectedKVId] = useState('');
  const [selectedKV, setSelectedKV] = useState(null);
  const [availableKVs, setAvailableKVs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Enhanced mock Active Visual Repository data - simulating data from Key Visual Management
  const mockActiveVisualRepository = [
    {
      kvId: 'LIS_BB_003',
      brandingType: 'Billboard', // Maps to branding_medium
      brandId: 'brand-1',
      brandName: 'Lily Skincare',
      brandCode: 'LIS',
      title: 'Summer Collection 2025',
      thumbnailUrl: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2025-01-01T00:00:00Z'
    },
    {
      kvId: 'LIS_BB_004',
      brandingType: 'Billboard',
      brandId: 'brand-1',
      brandName: 'Lily Skincare',
      brandCode: 'LIS',
      title: 'Anti-Aging Campaign',
      thumbnailUrl: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2024-12-15T00:00:00Z'
    },
    {
      kvId: 'LIS_BB_005',
      brandingType: 'Billboard',
      brandId: 'brand-1',
      brandName: 'Lily Skincare',
      brandCode: 'LIS',
      title: 'Winter Special',
      thumbnailUrl: null, // Testing gray placeholder
      url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2024-11-20T00:00:00Z'
    },
    {
      kvId: 'CAV_GB_003',
      brandingType: 'Gondola Branding',
      brandId: 'brand-2',
      brandName: 'Cavotin Haircare',
      brandCode: 'CAV',
      title: 'Hair Repair Formula',
      thumbnailUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2025-01-02T00:00:00Z'
    },
    {
      kvId: 'CAV_GB_004',
      brandingType: 'Gondola Branding',
      brandId: 'brand-2',
      brandName: 'Cavotin Haircare',
      brandCode: 'CAV',
      title: 'Natural Ingredients',
      thumbnailUrl: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2024-12-20T00:00:00Z'
    },
    {
      kvId: 'SAM_LS_003',
      brandingType: 'LED Screen',
      brandId: 'brand-3',
      brandName: 'Samsung',
      brandCode: 'SAM',
      title: 'Galaxy S25 Launch',
      thumbnailUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400',
      kvStatus: 'Active',
      fileType: 'video',
      duration: '1:30',
      createdAt: '2025-01-03T00:00:00Z'
    },
    {
      kvId: 'SAM_LS_004',
      brandingType: 'LED Screen',
      brandId: 'brand-3',
      brandName: 'Samsung',
      brandCode: 'SAM',
      title: 'Smart TV Collection',
      thumbnailUrl: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400',
      kvStatus: 'Active',
      fileType: 'video',
      duration: '2:00',
      createdAt: '2024-12-25T00:00:00Z'
    },
    {
      kvId: 'PON_WD_002',
      brandingType: 'Window Display',
      brandId: 'brand-4',
      brandName: 'Ponds',
      brandCode: 'PON',
      title: 'Vitamin C Series',
      thumbnailUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2025-01-04T00:00:00Z'
    },
    {
      kvId: 'PON_WD_003',
      brandingType: 'Window Display',
      brandId: 'brand-4',
      brandName: 'Ponds',
      brandCode: 'PON',
      title: 'Age Miracle Range',
      thumbnailUrl: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400',
      kvStatus: 'Active',
      fileType: 'image',
      createdAt: '2024-12-18T00:00:00Z'
    },
    // Archived KV (should be excluded)
    {
      kvId: 'LIS_BB_002',
      brandingType: 'Billboard',
      brandId: 'brand-1',
      brandName: 'Lily Skincare',
      brandCode: 'LIS',
      title: 'Old Campaign',
      thumbnailUrl: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=120&h=90&fit=crop',
      url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
      kvStatus: 'Archived', // Should be excluded
      fileType: 'image',
      createdAt: '2024-10-15T00:00:00Z'
    }
  ];

  const brands = [
    { id: 'brand-1', name: 'Lily Skincare', code: 'LIS' },
    { id: 'brand-2', name: 'Cavotin Haircare', code: 'CAV' },
    { id: 'brand-3', name: 'Samsung', code: 'SAM' },
    { id: 'brand-4', name: 'Ponds', code: 'PON' },
    { id: 'brand-5', name: 'Unilever', code: 'UNI' }
  ];

  useEffect(() => {
    if (isOpen && installation) {
      setLoading(true);
      setSelectedKVId('');
      setSelectedKV(null);

      // Filter KVs from Active Visual Repository with all requirements
      const filteredKVs = mockActiveVisualRepository?.filter(kv => {
        // 1. Must be Active (exclude Archived)
        if (kv?.kvStatus !== 'Active') return false;
        
        // 2. Must match branding medium
        if (kv?.brandingType !== installation?.brandingType) return false;
        
        // 3. Exclude currently assigned KV ID
        if (kv?.kvId === installation?.newKVId) return false;
        
        return true;
      });
      
      setAvailableKVs(filteredKVs);
      setLoading(false);
    }
  }, [isOpen, installation]);

  if (!isOpen || !installation) return null;

  const handleKVSelect = (kvId) => {
    setSelectedKVId(kvId);
    const kv = availableKVs?.find(item => item?.kvId === kvId);
    setSelectedKV(kv);
  };

  const validateSelection = () => {
    if (!selectedKVId) {
      alert('Please select a replacement KV.');
      return false;
    }

    if (!selectedKV) {
      alert('Selected KV not found in repository.');
      return false;
    }

    // Validate branding medium match
    if (selectedKV?.brandingType !== installation?.brandingType) {
      alert('Selected KV branding medium does not match the installation requirement.');
      return false;
    }

    return true;
  };

  const handleConfirm = () => {
    if (!validateSelection()) return;

    // Status reset rules
    let newStatus = installation?.status;
    let statusMessage = '';
    
    if (installation?.status?.toLowerCase() === 'verified') {
      newStatus = 'Planned';
      statusMessage = 'Status has been reset from Verified to Planned.';
    } else if (installation?.status?.toLowerCase() === 'installed') {
      newStatus = 'Installed';
      statusMessage = 'Status remains Installed. New image upload required before verification.';
    } else {
      statusMessage = 'Status remains Planned.';
    }

    // Prepare new KV reference data
    const newKVRef = {
      kvId: selectedKV?.kvId,
      thumbnailUrl: selectedKV?.thumbnailUrl,
      url: selectedKV?.url,
      duration: selectedKV?.duration,
      brandName: selectedKV?.brandName,
      title: selectedKV?.title,
      fileType: selectedKV?.fileType
    };

    // Create audit log entry
    const auditEntry = {
      timestamp: new Date()?.toISOString(),
      user: 'Current User', // Replace with actual user info
      action: 'KV_CHANGE',
      oldKVId: installation?.newKVId,
      newKVId: selectedKV?.kvId,
      installationId: installation?.id,
      brandingId: installation?.brandingId,
      storeName: installation?.storeName,
      statusChange: installation?.status !== newStatus ? `${installation?.status} → ${newStatus}` : 'No change'
    };

    // Call confirmation with all required data
    onConfirm?.(
      installation?.id, 
      installation?.newKVId, // old KV ID
      selectedKV?.kvId, // new KV ID  
      newKVRef, // new KV reference data
      newStatus, // updated status
      auditEntry // audit log
    );

    handleClose();
    
    alert(`KV successfully changed from ${installation?.newKVId} to ${selectedKV?.kvId}! ${statusMessage}`);
  };

  const handleClose = () => {
    setSelectedKVId('');
    setSelectedKV(null);
    onClose?.();
  };

  const currentKV = installation?.kvThumbnails?.new || {};
  const hasAvailableKVs = availableKVs?.length > 0;

  const GrayPlaceholder = ({ className = "", size = "small" }) => {
    const dimensions = size === "small" ? "w-12 h-9" : "w-16 h-12";
    return (
      <div className={`${dimensions} bg-gray-200 rounded border border-gray-300 flex items-center justify-center ${className}`}>
        <Icon name="Image" size={size === "small" ? 14 : 18} className="text-gray-500" />
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-background rounded-lg shadow-elevated max-w-3xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Change KV for Branding Item</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Select a replacement KV from Active Visual Repository
            </p>
          </div>
          <Button variant="ghost" size="icon" onClick={handleClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          {/* Context Information Block */}
          <div className="bg-muted/20 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-foreground mb-3">Context Block</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-muted-foreground">Store:</span>
                <span className="font-medium text-foreground ml-2">
                  {installation?.storeName}
                </span>
              </div>
              <div>
                <span className="text-muted-foreground">Store Code:</span>
                <span className="font-medium text-foreground ml-2">{installation?.storeCode}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Branding Medium:</span>
                <span className="font-medium text-foreground ml-2">{installation?.brandingType}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Branding ID:</span>
                <span className="font-mono text-sm font-medium text-primary ml-2">
                  {installation?.brandingId}
                </span>
              </div>
            </div>
          </div>

          {/* Current KV Preview */}
          <div className="mb-6">
            <h3 className="font-semibold text-foreground mb-3">Current KV Preview</h3>
            <div className="flex items-center gap-4 bg-blue-50/50 rounded-lg p-4 border border-blue-200">
              <div className="w-20 h-15 rounded border border-border overflow-hidden bg-muted/30 flex-shrink-0">
                {currentKV?.thumbnail || currentKV?.url ? (
                  <Image
                    src={currentKV?.thumbnail || currentKV?.url}
                    alt={`Current KV ${installation?.newKVId}`}
                    className="w-full h-full object-cover"
                    fallback={<GrayPlaceholder size="large" />}
                  />
                ) : (
                  <GrayPlaceholder size="large" />
                )}
              </div>
              <div>
                <div className="font-mono text-lg font-bold text-primary">
                  {installation?.newKVId}
                </div>
                {currentKV?.duration && (
                  <div className="text-sm text-muted-foreground flex items-center gap-1">
                    <Icon name="Play" size={12} />
                    Duration: {currentKV?.duration}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Select Replacement KV */}
          <div className="mb-6">
            <h3 className="font-semibold text-foreground mb-3">
              Select Replacement KV
            </h3>
            
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
                  <span className="text-muted-foreground">Loading KVs from Active Visual Repository...</span>
                </div>
              </div>
            ) : !hasAvailableKVs ? (
              /* Empty State */
              (<div className="text-center py-12 bg-amber-50/50 rounded-lg border border-amber-200">
                <Icon name="Search" size={48} className="text-amber-500 mx-auto mb-4" />
                <h4 className="text-lg font-medium text-amber-800 mb-2">No Key Visuals Available</h4>
                <p className="text-amber-700 text-sm max-w-md mx-auto">
                  No Key Visuals available for this branding medium ({installation?.brandingType}). 
                  Add one in Key Visual Management to enable KV replacement.
                </p>
              </div>)
            ) : (
              <div>
                {/* Dropdown showing KV options with thumbnails */}
                <div className="space-y-3">
                  <label className="block text-sm font-medium text-foreground">
                    Available KVs for {installation?.brandingType}:
                  </label>
                  
                  <div className="grid grid-cols-1 gap-3 max-h-80 overflow-y-auto">
                    {availableKVs?.map(kv => (
                      <div
                        key={kv?.kvId}
                        className={`flex items-center gap-4 p-3 border rounded-lg cursor-pointer transition-all ${
                          selectedKVId === kv?.kvId 
                            ? 'border-primary bg-primary/5 shadow-sm' 
                            : 'border-border hover:border-primary/50 hover:bg-muted/20'
                        }`}
                        onClick={() => handleKVSelect(kv?.kvId)}
                      >
                        {/* Radio button */}
                        <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                          selectedKVId === kv?.kvId 
                            ? 'border-primary bg-primary' :'border-gray-300'
                        }`}>
                          {selectedKVId === kv?.kvId && (
                            <div className="w-2 h-2 bg-white rounded-full"></div>
                          )}
                        </div>
                        
                        {/* KV Thumbnail */}
                        <div className="w-12 h-9 rounded border overflow-hidden flex-shrink-0">
                          {kv?.thumbnailUrl ? (
                            <Image
                              src={kv?.thumbnailUrl}
                              alt={`KV ${kv?.kvId}`}
                              className="w-full h-full object-cover"
                              fallback={<GrayPlaceholder />}
                            />
                          ) : (
                            <GrayPlaceholder />
                          )}
                        </div>
                        
                        {/* KV Information */}
                        <div className="flex-1">
                          <div className="font-mono text-sm font-semibold text-primary">
                            {kv?.kvId}
                          </div>
                          <div className="text-xs text-muted-foreground">
                            {kv?.brandName} • {kv?.title}
                          </div>
                          {kv?.duration && (
                            <div className="text-xs text-primary flex items-center gap-1 mt-1">
                              <Icon name="Play" size={10} />
                              {kv?.duration}
                            </div>
                          )}
                        </div>
                        
                        {/* File type indicator */}
                        <div className="text-xs text-muted-foreground">
                          <Icon name={kv?.fileType === 'video' ? 'Video' : 'Image'} size={14} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Selected KV Preview */}
                {selectedKV && (
                  <div className="mt-6 bg-green-50/50 rounded-lg p-4 border border-green-200">
                    <h4 className="font-medium text-green-800 mb-3 flex items-center gap-2">
                      <Icon name="Check" size={16} />
                      Selected KV Preview
                    </h4>
                    <div className="flex items-center gap-4">
                      <div className="w-20 h-15 rounded border border-green-300 overflow-hidden flex-shrink-0">
                        {selectedKV?.thumbnailUrl ? (
                          <Image
                            src={selectedKV?.url || selectedKV?.thumbnailUrl}
                            alt={`Selected KV ${selectedKV?.kvId}`}
                            className="w-full h-full object-cover"
                            fallback={<GrayPlaceholder size="large" className="border-green-300" />}
                          />
                        ) : (
                          <GrayPlaceholder size="large" className="border-green-300" />
                        )}
                      </div>
                      <div>
                        <div className="font-mono text-lg font-bold text-green-700">
                          {selectedKV?.kvId}
                        </div>
                        <div className="text-sm text-green-600">{selectedKV?.title}</div>
                        <div className="text-sm text-green-600">{selectedKV?.brandName}</div>
                        {selectedKV?.duration && (
                          <div className="text-sm text-green-600 flex items-center gap-1 mt-1">
                            <Icon name="Play" size={12} />
                            Duration: {selectedKV?.duration}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Status Reset Warning */}
          {selectedKVId && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
              <div className="flex items-start gap-3">
                <Icon name="AlertTriangle" size={16} className="text-amber-600 mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-medium text-amber-800 mb-2">Status Reset Rules</h4>
                  <div className="text-sm text-amber-700 space-y-1">
                    {installation?.status?.toLowerCase() === 'verified' ? (
                      <p><strong>Verified → Planned:</strong> Installation will need to be completed and verified again.</p>
                    ) : installation?.status?.toLowerCase() === 'installed' ? (
                      <p><strong>Installed → Installed:</strong> Status remains Installed but new photos required before verification.</p>
                    ) : (
                      <p><strong>Planned → Planned:</strong> Status remains unchanged.</p>
                    )}
                    <p className="mt-2 text-xs">Audit log will record: {installation?.newKVId} → {selectedKVId}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button 
            variant="default" 
            onClick={handleConfirm}
            disabled={!selectedKVId || !hasAvailableKVs || loading}
          >
            <Icon name="Check" size={16} />
            Confirm Change
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChangeKVModal;